module.exports = __webpack_public_path__ + "img/logo1.b2409509.png";